<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
export default {
    name: "App",

    data() {
        return {
            drawer: null,
            appBgClass: "",
        };
    },

    methods: {
        setAppBg(className) {
            this.appBgClass = className || "";
        },
    },

    watch: {
        appBgClass: {
            immediate: true,
            handler(newClass, oldClass) {
                const wrap = document.querySelector(".v-application--wrap");
                if (wrap) {
                    if (oldClass) wrap.classList.remove(oldClass);
                    if (newClass) wrap.classList.add(newClass);
                }
            },
        },
    },

    created() {
        this.$root.$on("set-app-bg", this.setAppBg);
    },
    beforeDestroy() {
        this.$root.$off("set-app-bg", this.setAppBg);
    },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap");
@import url("./styles/common.scss");
@import url("./styles/transitions.scss");
</style>
